import React from 'react'
import { Route, Link, NavLink as RouterNavLink } from "react-router-dom";
import {Row, Col} from 'reactstrap'
import Section from "../components/Section"



const CategoryNav = (props) => {
   
    console.log(props)
    
    let match = props.match
    console.log(match)
    return (
        <div>
           {props.menu.sections? props.menu.sections.map(section => (
                <Row>
                    <Link
                        tag={RouterNavLink}
                        to={`/section/${section._id}`}
                    >
                        <span><p className="category-title">{section.name.label}</p></span>
                    </Link>
                </Row>
           )): "loading"}
           <br></br>
           <Route exact path={`/section/:id`} render={(routeProps) => (
                 <Section {...routeProps} />
                 )}
            />
          
        </div>
    )
}
export default CategoryNav

//https://medium.com/swlh/defining-nested-routes-with-react-router-8f140e87b360